import ConversationHistoryView from './ConversationHistoryView'
import ConversationHistoryAdmin from './ConversationHistoryAdmin'
import {useEffect, useState} from 'react'
import ApiService from '../../../../common/ApiCalls'
import {useParams} from 'react-router-dom'

const useConversationHistory = () => {
    const [isOpen, setIsOpen] = useState(true)
    const [commentList, setCommentList] = useState([])
    const {id} = useParams()

    const viewSwitcher = (admin, index, data, label, formikProps) => {
        if(admin){
            return <ConversationHistoryAdmin index={index} data={data}  />
        }

        return <ConversationHistoryView index={index} admin={admin} data={data} commentList={commentList} />
    }

    const getComments = async () => {
        const res = await ApiService().getPaginatedComments(id, null, null, 1, 50)
        if(res&&res.comments){
            setCommentList(res.comments)
        }
    }

    useEffect(()=> {
        getComments()
    // XXX Fix this in the future
    // eslint-disable-next-line
    }, [])

    return {viewSwitcher, isOpen, setIsOpen}
}

export default useConversationHistory
